import { pubSub } from '@utils/PubSub';
import jsSHA from 'jssha';
export default class SplitOverlay {
  constructor(context) {
    this.elements = {
      $html: document.querySelector('html'),
      $overlay: context,
      $ecapform: context.querySelector('.overlay_partial_ecap_form'),
      $steps: context.querySelectorAll('.step'),
      $step1: context.querySelector('.step__1'),
      $step2: context.querySelector('.step__2'),
      $step3: context.querySelector('.step__3'),
      $step4: context.querySelector('.step__4'),
      $legal: context.querySelector('.overlay-step__sms-legal'),
      $close: context.querySelectorAll('.close--x'),
      $modalType: context.getAttribute('data-overlay-type'),
      step1_outer_height: '',
      step2_outer_height: '',
      step3_outer_height: '',
      step4_outer_height: '',
      $inputCapture: '',
    };
    pubSub.subscribe('dy:overlay:partial:init', () => {
      this.updateContentFromDY();
      this.initShopifyPartialOverlay();
    });
    this.buildNudge();
    this.checkCookie();

    // window.setInterval(checkCookie, 100); // run every 100 ms
    setInterval(() => {
      this.checkCookie;
    }, 100); // run every 100 ms
  }
  checkCookie() {
    let lastCookie = document.cookie; // 'static' memory between function calls
    return function () {
      let currentCookie = document.cookie;
      if (currentCookie != lastCookie) {
        // something useful like parse cookie, run a callback fn, etc.
        let submitCookie = document.cookie.indexOf('_dy_email_submited');
        let isSubmitted = submitCookie > -1 ? true : false;

        lastCookie = currentCookie; // store latest cookie

        if (isSubmitted === true) {
          let triggers = document.querySelectorAll('.nudge-trigger[active]');
          let postTriggers = document.querySelectorAll('.post-nudge-trigger[inactive]');
          triggers.forEach((trigger) => {
            trigger.removeAttribute('active');
            trigger.setAttribute('inactive', '');
            setTimeout(() => {
              trigger.classList.remove('show');
              trigger.classList.add('hide');
            }, 500);
          });
          postTriggers.forEach((postTrigger) => {
            postTrigger.removeAttribute('inactive');
            postTrigger.setAttribute('active', '');
            setTimeout(() => {
              postTrigger.classList.remove('hide');
              postTrigger.classList.add('show');
            }, 500);
          });

          clearInterval(checkSubmitCookie);
        }
      }
    };
  }
  buildNudge() {
    window.onclick = (e) => {
      let hasClass = e.target.classList.contains('nudge-trigger');
      if (hasClass) {
        document.dispatchEvent(new Event('dy:overlay:partial:init'));
      }
    };
    let nav = document.querySelector('#bkl-5-v1');
    let inboxWrapper = nav.querySelector('.site-header__extras');
    let nudge = inboxWrapper.querySelector('.inbox-nudge-wrapper');
    if (document.cookie.indexOf('_dy_email_submited') == -1) {
      const waitForPartial = () => {
        return new Promise((resolve, reject) => {
          const intervalId = setInterval(() => {
            if (window.Brooklinen?.partial) {
              clearInterval(intervalId);
              resolve(window.Brooklinen?.partial);
            }
          }, 100);
        });
      };

      waitForPartial().then(() => {
        nudge.setAttribute('active', '');
      });
    }
  }
  updateContentFromDY() {
    // populate code with dy content
    const { $overlay } = this.elements;

    const overlayPartial = $overlay;
    const step2 = overlayPartial.querySelector(`.step__2`);
    const emailForm = step2.querySelector(`.overlay_partial_ecap_form`);
    const emailKeyword = step2.querySelector(`#overlayPartial`);
    const emailLabel = step2.querySelector(`.email-input--placeholder`);

    const header = step2.querySelector(`.overlay-step__header`);
    const headerDesktop = header.querySelector(`.desktop`);
    const headerMobile = header.querySelector(`.mobile`);
    const caption = step2.querySelector(`.overlay-step__caption`);
    const captionDesktop = caption.querySelector(`.desktop`);
    const captionMobile = caption.querySelector(`.mobile`);
    const ctaPositive = step2.querySelector(`.overlay-step__cta-pos`);
    const positiveDesktop = ctaPositive.querySelector(`.desktop`);
    const positiveMobile = ctaPositive.querySelector(`.mobile`);
    const ctaNegative = step2.querySelector(`.overlay-step__cta-neg`);
    const negativeDesktop = ctaNegative.querySelector(`.desktop`);
    const negativeMobile = ctaNegative.querySelector(`.mobile`);

    const newHeaderDesktop = window.Brooklinen?.partial[0].desktop?.header;
    const newHeaderMobile = window.Brooklinen?.partial[0].mobile?.header;
    const newCaptionDesktop = window.Brooklinen?.partial[0].desktop?.caption;
    const newCaptionMobile = window.Brooklinen?.partial[0].mobile?.caption;
    const newPositiveDesktop = window.Brooklinen?.partial[0].desktop?.positive_cta;
    const newPositiveMobile = window.Brooklinen?.partial[0].mobile?.positive_cta;
    const newNegativeDesktop = window.Brooklinen?.partial[0].desktop?.negative_cta;
    const newNegativeMobile = window.Brooklinen?.partial[0].mobile?.negative_cta;
    const newEmailLabel = window.Brooklinen?.partial[0].email?.label;
    const newOverlayType = `ecap`;
    const newEmailKeyword = window.Brooklinen?.partial[0].email?.keyword;

    if (newHeaderDesktop !== '') {
      headerDesktop.innerHTML = newHeaderDesktop;
    }
    if (newHeaderMobile !== '') {
      headerMobile.innerHTML = newHeaderMobile;
    }
    if (newCaptionDesktop !== '') {
      captionDesktop.innerHTML = newCaptionDesktop;
    }
    if (newCaptionMobile !== '') {
      captionMobile.innerHTML = newCaptionMobile;
    }
    if (newPositiveDesktop !== '') {
      positiveDesktop.innerHTML = newPositiveDesktop;
    }
    if (newPositiveMobile !== '') {
      positiveMobile.innerHTML = newPositiveMobile;
    }
    if (newNegativeDesktop !== '') {
      negativeDesktop.innerHTML = newNegativeDesktop;
    }
    if (newNegativeMobile !== '') {
      negativeMobile.innerHTML = newNegativeMobile;
    }
    if (newOverlayType !== '') {
      overlayPartial.setAttribute(`data-overlay-type`, newOverlayType);
    }
    if (newEmailLabel !== '') {
      emailLabel.innerText = newEmailLabel;
    }
    if (newEmailKeyword !== '') {
      emailForm.setAttribute(`data-email-keyword`, newEmailKeyword);
    }
    window.Brooklinen = window.Brooklinen || {};
    window.Brooklinen.overlay = {
      step_2: {
        keyword: newEmailKeyword,
      },
    };
  }
  setOverlayHeight() {
    let { $step1, step1_outer_height, $step2, step2_outer_height, $step3, step3_outer_height, $step4, step4_outer_height, $overlay, $html } = this.elements;
    if ($step1) {
      step1_outer_height = `${$step1.offsetHeight}px`;
      $step1.style.maxHeight = step1_outer_height;
      $step1.style.height = step1_outer_height;
      this.elements.step1_outer_height = step1_outer_height;
    }
    if ($step2) {
      step2_outer_height = `${$step2.offsetHeight}px`;
      $step2.style.maxHeight = step2_outer_height;
      $step2.style.height = step2_outer_height;
      this.elements.step2_outer_height = step2_outer_height;
    }
    if ($step3) {
      step3_outer_height = `${$step3.offsetHeight}px`;
      $step3.style.maxHeight = step3_outer_height;
      $step3.style.height = step3_outer_height;
      this.elements.step3_outer_height = step3_outer_height;
    }
    if ($step4) {
      step4_outer_height = `${$step4.offsetHeight}px`;
      $step4.style.maxHeight = step4_outer_height;
      $step4.style.height = step4_outer_height;
      this.elements.step4_outer_height = step4_outer_height;
    }

    // set the default height to step 2
    setTimeout(() => {
      $overlay.style.maxHeight = step2_outer_height;
      $overlay.style.height = step2_outer_height;

      let scrolledPosition = window.scrollY;
      if (scrolledPosition > 0) document.body.style.top = `${scrolledPosition * -1}px`;

      $html.classList.add('lock-scroll-fixed');
      document.body.setAttribute('data-scrollable', false);
    }, 0);
  }
  setModalType() {
    let { $inputCapture, $step1, $step2, $step3, $step4, $overlay, $modalType, step2_outer_height, step3_outer_height } = this.elements;

    if ('single' === $modalType) {
      $inputCapture = 'none';
      this.elements.$inputCapture = 'none';
      $step2?.remove();
      $step3?.remove();
      $step4?.remove();
      $step1.classList.add('active');
    } else if ('ecap' === $modalType) {
      $inputCapture = 'ecap';
      this.elements.$inputCapture = 'ecap';
      $overlay.style.maxHeight = step2_outer_height;
      $overlay.style.height = step2_outer_height;
      $step1?.remove();
      $step2.classList.add('active');
      $step3?.remove();
      $step4?.remove();
    } else if ('sms' === $modalType) {
      $inputCapture = 'sms';
      this.elements.$inputCapture = 'sms';
      $overlay.style.maxHeight = step3_outer_height;
      $overlay.style.height = step3_outer_height;
      $step1?.remove();
      $step2?.remove();
      $step3.classList.add('active');
      $step4?.remove();
    } else if ('ecap3' === $modalType) {
      $inputCapture = 'ecap';
      this.elements.$inputCapture = 'ecap';
      $step3?.remove();
      $step1.classList.add('active');
    } else if ('sms3' === $modalType) {
      $inputCapture = 'sms';
      this.elements.$inputCapture = 'sms';
      $step2?.remove();
      $step1.classList.add('active');
    } else if ('ecap2' === $modalType) {
      $inputCapture = 'ecap';
      this.elements.$inputCapture = 'ecap';
      $overlay.style.maxHeight = step2_outer_height;
      $overlay.style.height = step2_outer_height;
      $step1?.remove();
      $step3?.remove();
      $step2.classList.add('active');
    } else if ('sms2' === $modalType) {
      $inputCapture = 'sms';
      this.elements.$inputCapture = 'sms';
      $overlay.style.maxHeight = step3_outer_height;
      $overlay.style.height = step3_outer_height;
      $step1?.remove();
      $step2?.remove();
      $step3.classList.add('active');
    } else if ('3ecap+sms' === $modalType) {
      $inputCapture = 'ecap+sms';
      this.elements.$inputCapture = 'ecap+sms';
      $overlay.style.maxHeight = step2_outer_height;
      $overlay.style.height = step2_outer_height;
      $step1?.remove();
      $step2.classList.add('active');
    } else if ('4ecap+sms' === $modalType) {
      $inputCapture = 'ecap+sms';
      this.elements.$inputCapture = 'ecap+sms';
      $step1.classList.add('active');
    } else {
      console.error('no type chosen');
    }
  }
  showClose() {
    let { $close } = this.elements;
    $close.forEach((closebtn) => {
      closebtn.classList.add('active');
    });
  }
  gotoStep(i) {
    let { $step1, $step2, $step3, $step4, $overlay, step2_outer_height, step3_outer_height } = this.elements,
      cur,
      next;
    if (i === 2) {
      cur = $step1;
      next = $step2;
      cur.classList.remove('active');
      $overlay.style.height = step2_outer_height;
      $overlay.style.maxHeight = step2_outer_height;

      setTimeout(function () {
        next.classList.add('active');
      }, 400);
    }
    if (i === 3) {
      cur = $step2;
      next = $step3;
      cur.classList.remove('active');
      setTimeout(function () {
        $overlay.style.height = step3_outer_height;
        $overlay.style.maxHeight = step3_outer_height;
      }, 200);

      setTimeout(function () {
        next.classList.add('active');
      }, 1400);
    }
    if (i === 4) {
      if ($inputCapture === 'ecap') {
        cur = $step2;
      } else {
        cur = $step3;
      }
      //cur = $step3;
      next = $step4;
      cur.classList.remove('active');

      setTimeout(function () {
        $overlay.style.height = step4_outer_height;
        $overlay.style.maxHeight = step4_outer_height;
        cur.style.height = step4_outer_height;
        cur.style.maxHeight = step4_outer_height;
      }, 400);

      setTimeout(function () {
        next.classList.add('active');
      }, 1600);
    }
  }
  closeModal() {
    let { $html, $steps, $overlay } = this.elements;
    // Always remove lock from body
    let previousPosition = parseInt(document.body.style.top.replace('px', '')) * -1;
    document.body.removeAttribute('data-scrollable');
    window.scrollTo(0, previousPosition);
    setTimeout(() => {
      $html.classList.remove('lock-scroll-fixed');
    }, 100);
    //Brooklinen.transitionHandler.fireEvent('openPartialOverlay', false);
    $steps.forEach((step) => {
      step.classList.remove('active');
      step.style.height = '0';
    });
    setTimeout(function () {
      $overlay.setAttribute('style', '');
    }, 400);
    setTimeout(function () {
      $overlay.classList.remove('active');
      $steps.forEach((step) => {
        step.setAttribute('style', '');
      });
    }, 800);

    // DY close event
    DY.API('event', { name: 'DY Capture Closed', properties: {} });
    // DY close cookie
    document.cookie = '_dy_email_capture_closed=true; path=/';
  }

  validateInput(currentEl) {
    // validate email and phone number input
    const inputType = currentEl.type,
      { $ecapform } = this.elements,
      validationRegex = {
        tel: /^1? ?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      };

    const passedValidation = () => validationRegex[inputType].test(currentEl.value);

    if (passedValidation()) {
      let validValue = inputType == 'tel' ? parseInt(inputEl.value.replace(/\D/g, '')) : currentEl.value;

      this.subscribeEmail(
        $ecapform,
        () => {
          this.emailDone(validValue);
        },
        validValue
      );

      const nanoText = window.Brooklinen?.partial[0].nano?.text;
      if (nanoText) this.updateNanoText(nanoText);
    } else this.outputError(inputType, currentEl);
  }

  updateNanoText(text) {
    document.cookie = `_dy_nano_updated=${text}; path=/`;
    pubSub.publish('nudge:submitted');
  }
  outputError(inputType, currentEl) {
    // depending on input type, add the appropriate text to error label
    let errorText = inputType == 'tel' ? 'Enter a valid phone number' : 'Enter a valid email address',
      { $ecapform } = this.elements,
      inputEl = currentEl,
      errorLabel = $ecapform.querySelector('.email-input--message');
    inputEl.classList.add('error');
    errorLabel.innerHTML = errorText;
    errorLabel.ariaHidden = false;
  }

  submitInputFields() {
    let { $inputCapture, $ecapform } = this.elements;
    let emailVal = document.querySelector('#overlay_partial_email').value;

    if ($inputCapture === 'ecap' || $inputCapture === 'ecap+sms') {
      if (emailVal.length > 0) {
        // commented out for development
        this.validateInput(document.querySelector('#overlay_partial_email'));
      }
    }
  }
  subscribeSMS(phoneNum) {
    // Remove all but digits from phone number
    phoneNum = phoneNum.replace(/\D+/g, '');

    let smsKeyword = document.querySelector('#overlayPartial').getAttribute('data-keyword');

    let psData = {
      phone: phoneNum,
      keyword: smsKeyword,
    };

    fetch('https://api.postscript.io/api/subscriber/add', {
      method: 'POST',
      dataType: 'json',
      mode: 'cors',
      contentType: 'application/json; charset=utf-8',
      headers: { authorization: 'd3f7002826826120fa2a1acec1ae9639' },
      body: JSON.stringify(psData),
    })
      .then((res) => res.json())
      .then((data) => {
        // Event tracking
        try {
          DY.API('event', {
            name: 'SMS Subscription',
            properties: {},
          });
        } catch (e) {
          console.log('DY ' + e);
        }

        if ($modalType === 'sms') {
          this.closeModal();
        } else {
          this.gotoStep(4);
        }
      });
  }
  validatePhoneNum(phoneNum) {
    let phoneRegex = /^1? ?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (phoneRegex.test(phoneNum)) {
      document.querySelector('.sms-error').style.display = 'none';
      return phoneNum;
    } else {
      document.querySelector('.sms-error').style.display = 'inline';
      return false;
    }
  }
  subscribeEmail(form, callback, email) {
    const dyKeyword = window.Brooklinen.overlay.step_2.keyword;
    const utmSrc = window?.Brooklinen?.getUrlData() || {};
    const signupSrc = 'overlay';
    const props = { signup_source: signupSrc, ...utmSrc };
    const timeStamp = new Date();
    const { htComponent } = form[0].dataset;
    const overlayType = !!htComponent && htComponent !== '' ? htComponent : 'overlay';

    const payload = {
      '@type': 'contact',
      '@collection': signupSrc,
      email: email,
      '@merge': true,
      marketing_optin: 'EXPLICITLY_OPTEDIN',
      timestamp_subscribed: timeStamp.toISOString(),
      properties: props,
    };

    fetch('https://brooklinen-ometria.herokuapp.com/api/contact', {
      method: 'POST',
      dataType: 'json',
      mode: 'cors',
      contentType: 'application/json; charset=utf-8',
      headers: {
        'X-Brooklinen-Auth': '0acf4539a14b3aa27deeb4cbdf6e989f',
        'content-type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        let shaObj = new jsSHA('SHA-256', 'TEXT');
        shaObj.update(email.toLowerCase());
        let emailHash = shaObj.getHash('HEX');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          submittedEmail: emailHash,
        });

        //Used for Ometria identify in GTM
        dataLayer.push({
          event: 'dl_subscribe',
          formLocation: 'partial_overlay',
        });

        if (data.ometria_contact === 'created') {
          try {
            heap.track('Email Optin', {
              email: email,
              signup_source: overlayType,
            });
            //console.log('email:', email, 'signup_source:', overlayType);
          } catch (e) {
            console.log(`Heap error ${e}`);
          }
        }
        callback(email);
      });

    callback(email);
  }

  emailDone(email) {
    let { $modalType } = this.elements;
    // Custom DY event for cookies
    try {
      DYO.StorageUtils.set('_dy_klaviyo_email', email, ['cookieStorage']);
      DYO.StorageUtils.set('_dy_emarsys_email', email, ['cookieStorage']);
    } catch (e) {
      console.log('DYO ' + e);
    }

    // Set DY records
    try {
      document.cookie = '_dy_email_submited=true; path=/';
      DY.API('identify', {
        uid: email,
        type: 'email',
      });
      document.querySelectorAll('.nudge-trigger').forEach((nudge) => {
        nudge.removeAttribute('active');
      });
    } catch (e) {
      console.log('DY ' + e);
    }

    // https://cdnjs.cloudflare.com/ajax/libs/jsSHA/2.3.1/sha.js
    // SHA256 encoding of the lowercase e-mail, in textual hexadecimal representation
    let shaObj = new jsSHA('SHA-256', 'TEXT');
    shaObj.update(email.toLowerCase());
    let emailHash = shaObj.getHash('HEX');

    // Use hashed email for DY subscribe event
    try {
      DY.API('event', {
        name: 'Newsletter Subscription',
        properties: {
          dyType: 'newsletter-subscription-v1',
          hashedEmail: emailHash,
        },
      });
    } catch (e) {
      console.log('DY ' + e);
    }

    // Fire FB pixel
    try {
      fbq('track', 'CompleteRegistration', {
        origin: 'DY',
        source: 'Entrance Overlay',
      });
    } catch (e) {
      console.log('fbq ' + e);
    }

    // Skip ahead to step 4 when there is no SMS capture.
    if ($modalType === 'ecap') {
      this.closeModal();
    } else if ('3ecap+sms' === $modalType || '4ecap+sms' === $modalType) {
      this.gotoStep(3);
    } else if ('ecap2' === $modalType || 'ecap3' === $modalType) {
      this.gotoStep(4);
    }
  }

  initShopifyPartialOverlay() {
    // Cashe DOM elms
    let { $html, $overlay, $ecapform, $steps, $step1, $step2, $step3, $step4, $legal, $close, $modalType, step1_outer_height, step2_outer_height, step3_outer_height, step4_outer_height, $inputCapture } = this.elements;

    this.setOverlayHeight();
    if ($modalType == '') {
      $modalType = $overlay.getAttribute('data-overlay-type');
      this.elements.$modalType = $overlay.getAttribute('data-overlay-type');
    }

    this.setModalType();

    $overlay.classList.add('active');
    this.showClose();

    document.addEventListener('keydown', (e) => {
      // ESCAPE key pressed
      if (e.keyCode == 27) {
        this.closeModal();
      }
    });

    // For step 1
    if ($step1) {
      $step1.querySelector('.next').addEventListener('click', function (e) {
        e.preventDefault();

        if ('single' === $modalType) {
          this.closeModal();
        } else if ('sms2' === $modalType || 'sms3' === $modalType) {
          this.gotoStep(3);
        } else {
          this.gotoStep(2);
        }
      });
    }

    if ($step3) {
      $step3.querySelector('.button.sms-submit').addEventListener('click', function (e) {
        e.preventDefault();
      });
    }

    // Events on any element that closes the modal
    $overlay.querySelectorAll('.close').forEach((closebtn) => {
      closebtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
      });
    });

    this.submitInputFields();

    // The button that submits the form
    $overlay.querySelector('.button.capture-submit').addEventListener('click', (e) => {
      e.preventDefault();
      this.submitInputFields();
    });
  }
}
